import React from "react";
import { FaCheck } from "react-icons/fa";

function ProviderFiltersBar({
  draft,
  onDraftChange,
  onApply,
  onReset,
  canApply = false,
  canReset = false,
  categoriesList = [],
  activeStatusOptions = [],
  headers = [],
}) {
  const showName = headers[1]?.checked !== false;
  const showCampus = headers[3]?.checked;
  const showCountry = headers[4]?.checked;
  const showCategory = headers[2]?.checked;
  const showStartDate = headers[5]?.checked;
  const showEndDate = headers[6]?.checked;

  return (
    <div
      className="cms-providers-filters-card"
      onKeyDown={(event) => {
        if (event.key === "Enter" && canApply) {
          event.preventDefault();
          onApply?.();
        }
      }}
    >
      <div className="cms-providers-filters-inner">
        <div className="cms-providers-filters-row">
          {showName && (
            <div className="cms-providers-filter-field">
              <label className="cms-providers-filter-label">Search Name</label>
              <input
                type="text"
                className="cms-providers-filter-input"
                placeholder="Provider name or ID"
                value={draft.name}
                onChange={(e) => onDraftChange({ ...draft, name: e.target.value })}
              />
            </div>
          )}

          {showCampus && (
            <div className="cms-providers-filter-field">
              <label className="cms-providers-filter-label">Search Campus</label>
              <input
                type="text"
                className="cms-providers-filter-input"
                placeholder="Search Campus"
                value={draft.campus}
                onChange={(e) => onDraftChange({ ...draft, campus: e.target.value })}
              />
            </div>
          )}

          {showCountry && (
            <div className="cms-providers-filter-field">
              <label className="cms-providers-filter-label">Search Country</label>
              <input
                type="text"
                className="cms-providers-filter-input"
                placeholder="Search Country"
                value={draft.country}
                onChange={(e) => onDraftChange({ ...draft, country: e.target.value })}
              />
            </div>
          )}

          {showStartDate && (
            <div className="cms-providers-filter-field">
              <label className="cms-providers-filter-label">Start Date</label>
              <input
                type="date"
                className="cms-providers-filter-input"
                value={draft.startDate}
                onChange={(e) => onDraftChange({ ...draft, startDate: e.target.value })}
              />
            </div>
          )}

          {showEndDate && (
            <div className="cms-providers-filter-field">
              <label className="cms-providers-filter-label">End Date</label>
              <input
                type="date"
                className="cms-providers-filter-input"
                value={draft.endDate}
                onChange={(e) => onDraftChange({ ...draft, endDate: e.target.value })}
              />
            </div>
          )}

          {showCategory && (
            <div className="cms-providers-filter-field">
              <label className="cms-providers-filter-label">Search Category</label>
              <select
                className="cms-providers-filter-select"
                value={draft.category}
                onChange={(e) => onDraftChange({ ...draft, category: e.target.value })}
              >
                <option value="">All categories</option>
                {categoriesList.map((item) => (
                  <option key={item.id} value={item.title}>
                    {item.title}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div className="cms-providers-filter-field">
            <label className="cms-providers-filter-label">Active Status</label>
            <select
              className="cms-providers-filter-select"
              value={draft.activeStatus}
              onChange={(e) => onDraftChange({ ...draft, activeStatus: e.target.value })}
            >
              {activeStatusOptions.map((item) => (
                <option key={item.title} value={item.title}>
                  {item.title}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="cms-providers-filters-footer">
          <div className="cms-providers-filters-actions">
            <button
              type="button"
              className="cms-providers-filter-reset-btn"
              onClick={onReset}
              disabled={!canReset}
            >
              Reset
            </button>
            <button
              type="button"
              className="cms-providers-filter-apply-btn"
              onClick={onApply}
              disabled={!canApply}
            >
              <FaCheck size={10} />
              Apply Filters
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProviderFiltersBar;
